import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NewContact from '@/components/NewContact'
import Case from '@/components/Case'
import newsCase from '@/components/newsCase'
import favour from '@/components/favour'
import AddedCase from '@/components/mycase/AddCase'
import AddedNiceCase from '@/components/mycase/AddNiceCase'
import RelatedInfo from '@/components/mycase/RelatedInfo'
import AlarmRelatedInfo from '@/components/mycase/AlarmRelatedInfo'
import handlingCase from '@/components/handlingCase'
import CaseDetail from '@/components/mycase/CaseDetail'
import AlarmCaseDetail from '@/components/mycase/AlarmCaseDetail'
import AlarmInfo from '@/components/mycase/AlarmInfo'
import AlarmList from '@/components/alarmList'
import NiceCaseList from '@/components/niceCaseList'
import NiceCaseInfo from '@/components/mycase/NiceCaseInfo'
import AlarmAddedCase from '@/components/mycase/AlarmAddCase'
import AlarmAssign from '@/components/mycase/Assign'
import Chat from '@/components/Chat'
import newsCore from '@/components/newsCore'
import newsCoreDetail from '@/components/newsCoreDetail'
import statisticsData from '@/components/statisticsData'
import restDay from '@/components/restDay'
import setWorkingHours from '@/components/setWorkingHours'
import newsCoreRead from '@/components/newsCoreRead'
import excel from '@/components/excel'
import alarmExcel from '@/components/alarmExcel'
import NiceCase from '@/components/niceCase'
import dandangguanli from '@/components/dandangguanli'
import newsChat from '@/components/newsChat'
import IndexMenu from '@/components/indexMenu/index.vue'
import Quality from '@/components/quality/index.vue'
import QualityTmci from '@/components/quality/index_tmci.vue'
import QualityUploadData from '@/components/quality/uploadData.vue'
import PendingApproval from '@/components/quality/pending-approval.vue'
import DataList from '@/components/quality/datalist.vue'
import QualityDetail from '@/components/quality/detail.vue'
import QualityDetailtui from '@/components/quality/detailtui.vue'
import QualityDetails from '@/components/quality/details.vue'
import error from './views/Error.vue'
import App from './App.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home/:Type/:Token',
      name: 'home',
      component: Home
    },
    {
      path: '/indexMenu',
      name: 'indexMenu',
      component: IndexMenu
    },
    {
      path: '/quality',
      name: 'quality',
      component: Quality
    },
    {
      path: '/quality-tmci',
      name: 'qualityTmci',
      component: QualityTmci
    },
    {
      path: '/qualityDetails/:ticketNum/:vin',
      name: 'qualityDetails',
      component: QualityDetails
    },
    {
      path: '/qualityDetail/:ticketNum/:vin',
      name: 'qualityDetail',
      component: QualityDetail
    },
    {
      path: '/qualityDetailtui/:ticketNum/:vin',
      name: 'qualityDetail',
      component: QualityDetailtui
    },
    {
      path: '/qualityUploadData/:id',
      name: 'qualityUploadData',
      component: QualityUploadData
    },
    {
      path: '/dataList/:status',
      name: 'dataList',
      component: DataList
    },
    {
      path: '/pendingApproval/:caseNo/:vin',
      name: 'pendingApproval',
      component: PendingApproval
    },
    {
      path: '/home/:BusinessType/:Type/:Token/:CaseId/:Status', // 微信企业号跳转地址
      name: 'home',
      component: Home
    },
    {
      path: '/home/:BusinessType/:Type/:Token', // 微信企业号跳转地址
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
                import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/newcontact', // 和router-link to相呼应，导航到/newcontact
      name: 'NewContact',
      component: NewContact
    },
    {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/newsCase/:status', // 最新案例
      name: 'newsCase',
      component: newsCase
    }, {
      path: '/alarmList', // 最新案例
      name: 'AlarmList',
      component: AlarmList
    }, {
      path: '/niceCaseList', // 好事例
      name: 'NiceCaseList',
      component: NiceCaseList
    }, {
      path: '/niceCaseInfo/:id', // 好事例详情
      name: 'NiceCaseInfo',
      component: NiceCaseInfo
    }, {
      path: '/favour/:status', // 最新案例
      name: 'favour',
      component: favour
    }, {
      path: '/addedCase/:id', // 发起案件
      name: 'addedCase',
      component: AddedCase
    }, {
      path: '/addedNiceCase/:id', // 发起案件
      name: 'addedNiceCase',
      component: AddedNiceCase
    }, {
      path: '/alarmAddedCase/:id', // 三包预警发起案件
      name: 'alarmAddedCase',
      component: AlarmAddedCase
    }, {
      path: '/casedetail/:status/:id', // 案件详情
      name: 'caseDetail',
      component: CaseDetail
    }, {
      path: '/alarmcasedetail/:status/:id', // 预警案件详情
      name: 'alarmcaseDetail',
      component: AlarmCaseDetail
    },
    {
      path: '/alarmInfo/:status/:id', // 三包预警详情
      name: 'alarmInfo',
      component: AlarmInfo
    },
    {
      path: '/alarmInfo/:Type?/:Token?/:status?/:id', // 三包预警详情
      name: 'alarmInfo',
      component: AlarmInfo
    }, {
      path: '/alarmAssign/:id', // 三包预警详情
      name: 'alarmAssign',
      component: AlarmAssign
    }, {
      path: '/handlingCase', // 处理中案件
      name: 'handlingCase',
      component: handlingCase
    }, {
      path: '/relatedinfo/:id', // 相关信息
      name: 'relatedinfo',
      component: RelatedInfo
    }, {
      path: '/alarmrelatedinfo/:id', // 相关信息
      name: 'alarmrelatedinfo',
      component: AlarmRelatedInfo
    }, {
      path: '/chat', // 发起案件
      name: 'caseDetail',
      component: Chat
    }, {
      path: '/newsCore', // 未读消息中心
      name: 'newsCore',
      component: newsCore
    }, {
      path: '/newsCoreRead', // 已读消息中心
      name: 'newsCoreRead',
      component: newsCoreRead
    }, {
      path: '/newsCoreDetail', // 消息中心
      name: 'newsCoreDetail',
      component: newsCoreDetail
    }, {
      path: '/statisticsData', // 消息中心
      name: 'statisticsData',
      component: statisticsData
    }, {
      path: '/restDay', // 休息日
      name: 'restDay',
      component: restDay
    }, {
      path: '/setWorkingHours', // 设置工作时间
      name: 'setWorkingHours',
      component: setWorkingHours
    }, {
      path: '/excel', // excel导出
      name: 'excel',
      component: excel
    }, {
      path: '/alarmExcel', // excel导出
      name: 'alarmExcel',
      component: alarmExcel
    }, {
      path: '/niceCase', // 好事例管理
      name: 'niceCase',
      component: NiceCase
    }, {
      path: '/dandangguanli', // 担当管理
      name: 'dandangguanli',
      component: dandangguanli
    }, {
      path: '/newsChat/:status/:id', // 发起案件
      name: 'newsChat',
      component: newsChat
    }, {
      path: '/error', // 发起案件
      name: 'error',
      component: error
    }
  ]
})
